(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["add-to-home"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (window.innerWidth > 768) return;
  var box = document.querySelector('[data-a2h]');
  if (!box) return;

  // iOS cannot do one-tap install — hide popup entirely for iPhone/iPad
  function isIOS() { return /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream; }
  if (isIOS()) return;

  var delay = (parseInt(box.getAttribute('data-delay'), 10) || 3) * 1000;
  var cooldown = (parseInt(box.getAttribute('data-cooldown'), 10) || 7) * 24 * 60 * 60 * 1000;
  var KEY = 'sm_a2h_dismissed';
  var deferredPrompt = null;

  // Already installed?
  if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) return;

  // Dismissed recently?
  try {
    var d = localStorage.getItem(KEY);
    if (d && (Date.now() - parseInt(d, 10)) < cooldown) return;
  } catch (e) {}

  function hide() {
    box.hidden = true;
    try { localStorage.setItem(KEY, Date.now().toString()); } catch (e) {}
  }

  // Capture Android native install prompt
  window.addEventListener('beforeinstallprompt', function(e) {
    e.preventDefault();
    deferredPrompt = e;
  });

  // Only show popup after delay IF install is actually available (Android Chrome)
  setTimeout(function() {
    if (deferredPrompt) {
      box.hidden = false;
    }
  }, delay);

  var installBtn = box.querySelector('[data-a2h-install]');
  if (installBtn) {
    installBtn.addEventListener('click', function() {
      if (deferredPrompt) {
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then(function() { deferredPrompt = null; hide(); });
      } else {
        hide();
      }
    });
  }

  box.querySelectorAll('[data-a2h-close]').forEach(function(el) {
    el.addEventListener('click', hide);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deals"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-sm-deals]').forEach(function (el) {
    var endStr = el.getAttribute('data-end');
    var timer = el.querySelector('[data-deals-timer]');
    if (!endStr || !timer) return;
    var end = new Date(endStr).getTime();
    if (isNaN(end)) return;

    var dEl = timer.querySelector('[data-days]');
    var hEl = timer.querySelector('[data-hours]');
    var mEl = timer.querySelector('[data-mins]');
    var sEl = timer.querySelector('[data-secs]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        clearInterval(iv);
        if (el.getAttribute('data-expire') === 'hide') { el.classList.add('is-expired'); }
        else { dEl.textContent = hEl.textContent = mEl.textContent = sEl.textContent = '00'; }
        return;
      }
      dEl.textContent = pad(Math.floor(diff / 86400000));
      hEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      mEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      sEl.textContent = pad(Math.floor((diff % 60000) / 1000));
    }
    tick();
    var iv = setInterval(tick, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initCarousel() {
    if (window.innerWidth > 768) return;
    var grids = document.querySelectorAll('[data-home-carousel]');
    if (!grids.length) return;
    var styleEl = document.createElement('style');
    styleEl.textContent = '[data-home-carousel]::-webkit-scrollbar{display:none}';
    document.head.appendChild(styleEl);
    grids.forEach(function(grid) {
      grid.style.display = 'flex';
      grid.style.flexWrap = 'nowrap';
      grid.style.overflowX = 'scroll';
      grid.style.overflowY = 'hidden';
      grid.style.webkitOverflowScrolling = 'touch';
      grid.style.scrollSnapType = 'x mandatory';
      grid.style.gap = '14px';
      grid.style.padding = '4px 16px 12px 16px';
      grid.style.margin = '0 -16px';
      grid.style.scrollbarWidth = 'none';
      grid.style.msOverflowStyle = 'none';
      Array.from(grid.children).forEach(function(card) {
        card.style.flex = '0 0 72%';
        card.style.scrollSnapAlign = 'start';
        card.style.minWidth = '0';
      });
    });
  }
  setTimeout(initCarousel, 100);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-sm-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('[data-hero-slide]');
    if (slides.length < 2) return;
    var dots = hero.querySelectorAll('[data-hero-dot]');
    var current = 0, timer;
    var delay = parseInt(hero.getAttribute('data-autoplay'), 10) || 4500;

    function show(n) {
      slides[current].classList.remove('is-active');
      if (dots[current]) { dots[current].classList.remove('is-active'); dots[current].setAttribute('aria-selected','false'); }
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) { dots[current].classList.add('is-active'); dots[current].setAttribute('aria-selected','true'); }
    }
    function start() { timer = setInterval(function () { show(current + 1); }, delay); }
    function reset() { clearInterval(timer); start(); }

    var prev = hero.querySelector('[data-hero-prev]');
    var next = hero.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); reset(); });
    if (next) next.addEventListener('click', function () { show(current + 1); reset(); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); reset(); }); });
    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
(function () {
  var newBtn = document.querySelector('[data-addr-new]');
  var newForm = document.getElementById('sm-addr-new');
  if (newBtn && newForm) {
    newBtn.addEventListener('click', function () { newForm.hidden = !newForm.hidden; });
    var cancel = newForm.querySelector('[data-addr-cancel]');
    if (cancel) cancel.addEventListener('click', function () { newForm.hidden = true; });
  }
  document.querySelectorAll('[data-addr-edit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var f = document.getElementById('sm-addr-edit-' + btn.dataset.addrEdit);
      if (f) f.hidden = !f.hidden;
    });
  });
  document.querySelectorAll('[data-addr-edit-cancel]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var f = document.getElementById('sm-addr-edit-' + btn.dataset.addrEditCancel);
      if (f) f.hidden = true;
    });
  });
  document.querySelectorAll('[data-confirm-message]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { if (!confirm(btn.dataset.confirmMessage)) e.preventDefault(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-sm-cartpage]');
  if (!root) return;
  var SM = window.ShoppingMood || {};
  var fmt = (SM.money && SM.money.format) || '₹{{amount}}';
  function money(c) { return fmt.replace(/\{\{\s*amount\s*\}\}/, (c / 100).toFixed(2)); }

  function change(key, qty) {
    fetch(SM.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      var row = root.querySelector('[data-line-key="' + key + '"]');
      var item = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!item && row) { row.remove(); }
      else if (item && row) {
        row.querySelector('[data-line-input]').value = item.quantity;
        row.querySelector('.sm-cartpage__line').textContent = money(item.final_line_price);
      }
      root.querySelectorAll('[data-cart-subtotal],[data-cart-total]').forEach(function (n) { n.textContent = money(cart.total_price); });
      document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
      if (cart.item_count === 0) window.location.reload();
    });
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (btn) {
      var row = btn.closest('[data-line-key]');
      var input = row.querySelector('[data-line-input]');
      var q = parseInt(input.value, 10) + parseInt(btn.dataset.lineChange, 10);
      if (q < 0) q = 0;
      change(row.dataset.lineKey, q);
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { change(rm.closest('[data-line-key]').dataset.lineKey, 0); }
  });
  root.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-input]');
    if (input) { var q = parseInt(input.value, 10); if (isNaN(q) || q < 0) q = 0; change(input.closest('[data-line-key]').dataset.lineKey, q); }
  });

  var note = root.querySelector('[data-cart-note]');
  if (note) {
    var t;
    note.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        fetch(SM.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
      }, 600);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-sm-collection]');
  if (!root) return;

  /* Sort */
  var sortSelect = root.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* Auto-apply filters on change */
  var filterForm = root.querySelector('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', function () {
      var params = new URLSearchParams();
      filterForm.querySelectorAll('input').forEach(function (input) {
        if (input.type === 'checkbox') {
          if (input.checked) params.append(input.name, input.value);
        } else if (input.value) {
          params.append(input.name, input.value);
        }
      });
      var sortVal = sortSelect ? sortSelect.value : null;
      if (sortVal) params.set('sort_by', sortVal);
      window.location.search = params.toString();
    });
  }

  /* Mobile filter drawer */
  var filters = root.querySelector('[data-filters]');
  var backdrop = root.querySelector('.sm-filters__backdrop');
  function openFilters() { if (filters) filters.classList.add('is-open'); if (backdrop) backdrop.hidden = false; document.body.style.overflow = 'hidden'; }
  function closeFilters() { if (filters) filters.classList.remove('is-open'); if (backdrop) backdrop.hidden = true; document.body.style.overflow = ''; }
  root.querySelectorAll('[data-filters-open]').forEach(function (b) { b.addEventListener('click', openFilters); });
  root.querySelectorAll('[data-filters-close]').forEach(function (b) { b.addEventListener('click', closeFilters); });

  /* Infinite scroll */
  var infinite = root.querySelector('[data-infinite]');
  if (infinite) {
    var grid = root.querySelector('[data-product-grid]');
    var nextLink = infinite.querySelector('[data-infinite-next]');
    var endMsg = infinite.querySelector('.sm-infinite__end');
    var loading = false;

    function loadNext() {
      if (loading || !nextLink) return;
      loading = true;
      nextLink.classList.add('is-loading');
      nextLink.textContent = 'Loading...';
      fetch(nextLink.href)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('[data-product-grid] > .sm-card');
          newCards.forEach(function (card) { grid.appendChild(card); });
          var newNext = doc.querySelector('[data-infinite-next]');
          if (newNext) {
            nextLink.href = newNext.href;
            nextLink.classList.remove('is-loading');
            nextLink.textContent = 'Load More Products';
            loading = false;
            try {
              var url = new URL(newNext.href);
              window.history.replaceState({}, '', url.searchParams.get('page') ? window.location.pathname + '?page=' + url.searchParams.get('page') : window.location.pathname);
            } catch (e) {}
          } else {
            nextLink.remove();
            if (endMsg) endMsg.hidden = false;
          }
          if (window.ShoppingMood && window.ShoppingMood.refreshWishlist) window.ShoppingMood.refreshWishlist();
        })
        .catch(function () {
          nextLink.classList.remove('is-loading');
          nextLink.textContent = 'Load More Products';
          loading = false;
        });
    }

    if (nextLink) {
      nextLink.addEventListener('click', function (e) { e.preventDefault(); loadNext(); });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { if (entry.isIntersecting) loadNext(); });
        }, { rootMargin: '400px' });
        io.observe(infinite);
      }
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
(function () {
  var login = document.getElementById('sm-login');
  var recover = document.getElementById('sm-recover');
  if (!login || !recover) return;
  document.querySelectorAll('[data-show-recover]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); login.hidden = true; recover.hidden = false; });
  });
  document.querySelectorAll('[data-show-login]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); recover.hidden = true; login.hidden = false; });
  });
  if (window.location.hash === '#recover') { login.hidden = true; recover.hidden = false; }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-sm-product]');
  if (!root) return;

  /* Variant selection */
  var select = root.querySelector('[data-variant-select]');
  var swatches = root.querySelectorAll('[data-option-input]');
  var priceEl = root.querySelector('[data-price]');
  var compareEl = root.querySelector('[data-compare]');

  function currentOptions() {
    var opts = [];
    root.querySelectorAll('.sm-pdp__option').forEach(function (group) {
      var checked = group.querySelector('input:checked');
      if (checked) opts.push(checked.value);
    });
    return opts;
  }
  function updateVariant() {
    if (!select) return;
    var opts = currentOptions();
    var options = select.querySelectorAll('option');
    options.forEach(function (opt) {
      if (opt.textContent.indexOf(opts.join(' / ')) === 0 || opt.textContent.trim() === opts.join(' / ')) {
        select.value = opt.value;
        if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        if (compareEl && opt.dataset.compare) compareEl.textContent = opt.dataset.compare;
      }
    });
  }
  swatches.forEach(function (input) {
    input.addEventListener('change', function () {
      var group = input.closest('.sm-pdp__option');
      group.querySelectorAll('.sm-pdp__swatch').forEach(function (s) { s.classList.remove('is-active'); });
      input.closest('.sm-pdp__swatch').classList.add('is-active');
      updateVariant();
    });
  });

  /* Gallery thumbs */
  var mainWrap = root.querySelector('.sm-gallery__main');
  root.querySelectorAll('.sm-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      root.querySelectorAll('.sm-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (thumb.dataset.mediaType === 'video' && thumb.dataset.video) {
        mainWrap.innerHTML = '<video controls autoplay playsinline><source src="' + thumb.dataset.video + '" type="video/mp4"></video>';
      } else {
        mainWrap.innerHTML = '<img id="sm-gallery-main" src="' + thumb.dataset.full + '" alt="">';
      }
    });
  });

  /* Buy Now handled natively by Shopify via name="checkout" on submit button */

  /* Sticky ATC */
  var sticky = root.querySelector('[data-sticky-atc]');
  var addBtn = root.querySelector('.sm-pdp__add');
  if (sticky && addBtn && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { sticky.hidden = entry.isIntersecting; });
    }, { rootMargin: '0px 0px -200px 0px' });
    io.observe(addBtn);
    var stickyAdd = sticky.querySelector('[data-sticky-add]');
    if (stickyAdd) stickyAdd.addEventListener('click', function () { addBtn.click(); });
  }

  /* Record recently viewed */
  try {
    var handle = "{{ product.handle }}";
    var key = 'sm_recently_viewed';
    var list = JSON.parse(localStorage.getItem(key)) || [];
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    list = list.slice(0, 12);
    localStorage.setItem(key, JSON.stringify(list));
  } catch (e) {}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"]) return;
  try {
    
(function () {
  var grid = document.querySelector('[data-wishlist-grid]');
  var loading = document.querySelector('[data-wishlist-loading]');
  var empty = document.querySelector('[data-wishlist-empty]');
  if (!grid) return;

  var list = [];
  try { list = JSON.parse(localStorage.getItem('sm_wishlist')) || []; } catch (e) {}

  function done(hasItems) {
    if (loading) loading.hidden = true;
    if (hasItems) { grid.hidden = false; } else { if (empty) empty.hidden = false; }
  }
  if (list.length === 0) { done(false); return; }

  var fmt = (window.ShoppingMood && window.ShoppingMood.money && window.ShoppingMood.money.format) || '₹{{amount}}';
  function money(c) { return fmt.replace(/\{\{\s*amount\s*\}\}/, (c / 100).toFixed(2)); }

  Promise.all(list.map(function (h) {
    return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  })).then(function (products) {
    var html = '';
    products.forEach(function (p) {
      if (!p) return;
      var img = p.featured_image ? p.featured_image.replace(/(\.[^.]*)$/, '_600x$1') : '';
      var compare = '';
      if (p.compare_at_price > p.price) { compare = '<span class="sm-card__was">' + money(p.compare_at_price) + '</span>'; }
      html += '<article class="sm-card"><div class="sm-card__media">' +
        '<a href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
        '<button type="button" class="sm-card__wish is-active" data-wishlist-toggle="' + p.handle + '"><i class="fas fa-heart"></i></button>' +
        '</div><div class="sm-card__info">' +
        '<h3 class="sm-card__title"><a href="' + p.url + '">' + p.title + '</a></h3>' +
        '<div class="sm-card__price"><span class="sm-card__now">' + money(p.price) + '</span>' + compare + '</div>' +
        '<a href="' + p.url + '" class="sm-btn sm-btn--primary sm-btn--full" style="font-size:13px;padding:11px;border-radius:12px;"><i class="fas fa-shopping-bag"></i> View Product</a>' +
        '</div></article>';
    });
    if (html) { grid.innerHTML = html; done(true); if (window.ShoppingMood && window.ShoppingMood.refreshWishlist) window.ShoppingMood.refreshWishlist(); }
    else { done(false); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
(function () {
  var section = document.querySelector('[data-recently-viewed]');
  if (!section) return;
  var row = section.querySelector('[data-recent-row]');
  var currentHandle = "{{ product.handle }}";
  var list = [];
  try { list = JSON.parse(localStorage.getItem('sm_recently_viewed')) || []; } catch (e) {}
  list = list.filter(function (h) { return h && h !== currentHandle; }).slice(0, 8);
  if (list.length < 1) return;

  var fmt = (window.ShoppingMood && window.ShoppingMood.money && window.ShoppingMood.money.format) || '₹{{amount}}';
  function money(cents) { return fmt.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2)); }

  Promise.all(list.map(function (handle) {
    return fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  })).then(function (products) {
    var html = '';
    products.forEach(function (p) {
      if (!p) return;
      var img = p.featured_image ? p.featured_image.replace(/(\.[^.]*)$/, '_320x$1') : '';
      html += '<div class="sm-recent__card"><a href="' + p.url + '">' +
        '<div class="sm-recent__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="sm-recent__name">' + p.title + '</div>' +
        '<div class="sm-recent__price">' + money(p.price) + '</div>' +
        '</a></div>';
    });
    if (html) { row.innerHTML = html; section.hidden = false; }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-age"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('.sm-shopage--animated');
  var canvas = section ? section.querySelector('.sm-shopage__canvas') : null;
  if (!canvas) return;
  var ctx = canvas.getContext('2d');

  // Draw real SVG-style kids clothing using canvas paths
  var drawers = {
    frock: function(ctx, s) {
      // Body
      ctx.beginPath();
      ctx.moveTo(s*0.35,s*0.28);
      ctx.lineTo(s*0.65,s*0.28);
      ctx.lineTo(s*0.72,s*0.45);
      ctx.lineTo(s*0.85,s*0.95);
      ctx.lineTo(s*0.15,s*0.95);
      ctx.lineTo(s*0.28,s*0.45);
      ctx.closePath();
      ctx.fill();
      // Collar left
      ctx.beginPath();
      ctx.moveTo(s*0.35,s*0.28);
      ctx.lineTo(s*0.28,s*0.08);
      ctx.lineTo(s*0.45,s*0.28);
      ctx.closePath();
      ctx.fill();
      // Collar right
      ctx.beginPath();
      ctx.moveTo(s*0.65,s*0.28);
      ctx.lineTo(s*0.72,s*0.08);
      ctx.lineTo(s*0.55,s*0.28);
      ctx.closePath();
      ctx.fill();
      // Waist band
      ctx.fillStyle='rgba(255,255,255,0.25)';
      ctx.fillRect(s*0.28,s*0.42,s*0.44,s*0.06);
    },
    tshirt: function(ctx, s) {
      // Body
      ctx.beginPath();
      ctx.moveTo(s*0.28,s*0.32);
      ctx.lineTo(s*0.72,s*0.32);
      ctx.lineTo(s*0.72,s*0.88);
      ctx.lineTo(s*0.28,s*0.88);
      ctx.closePath();
      ctx.fill();
      // Left sleeve
      ctx.beginPath();
      ctx.moveTo(s*0.28,s*0.32);
      ctx.lineTo(s*0.05,s*0.22);
      ctx.lineTo(s*0.08,s*0.48);
      ctx.lineTo(s*0.28,s*0.52);
      ctx.closePath();
      ctx.fill();
      // Right sleeve
      ctx.beginPath();
      ctx.moveTo(s*0.72,s*0.32);
      ctx.lineTo(s*0.95,s*0.22);
      ctx.lineTo(s*0.92,s*0.48);
      ctx.lineTo(s*0.72,s*0.52);
      ctx.closePath();
      ctx.fill();
      // Neck
      ctx.beginPath();
      ctx.arc(s*0.5,s*0.32,s*0.12,0,Math.PI,false);
      ctx.fillStyle='rgba(255,255,255,0.2)';
      ctx.fill();
    },
    pant: function(ctx, s) {
      // Waistband
      ctx.fillRect(s*0.18,s*0.05,s*0.64,s*0.12);
      // Left leg
      ctx.beginPath();
      ctx.moveTo(s*0.18,s*0.17);
      ctx.lineTo(s*0.5,s*0.17);
      ctx.lineTo(s*0.48,s*0.95);
      ctx.lineTo(s*0.14,s*0.95);
      ctx.closePath();
      ctx.fill();
      // Right leg
      ctx.beginPath();
      ctx.moveTo(s*0.5,s*0.17);
      ctx.lineTo(s*0.82,s*0.17);
      ctx.lineTo(s*0.86,s*0.95);
      ctx.lineTo(s*0.52,s*0.95);
      ctx.closePath();
      ctx.fill();
      // Belt highlight
      ctx.fillStyle='rgba(255,255,255,0.2)';
      ctx.fillRect(s*0.18,s*0.05,s*0.64,s*0.04);
    },
    cap: function(ctx, s) {
      // Brim
      ctx.beginPath();
      ctx.ellipse(s*0.45,s*0.62,s*0.46,s*0.12,0,0,Math.PI*2);
      ctx.fill();
      // Crown
      ctx.beginPath();
      ctx.arc(s*0.45,s*0.38,s*0.34,Math.PI,0,false);
      ctx.lineTo(s*0.79,s*0.62);
      ctx.lineTo(s*0.11,s*0.62);
      ctx.closePath();
      ctx.fill();
      // Button on top
      ctx.fillStyle='rgba(255,255,255,0.4)';
      ctx.beginPath();
      ctx.arc(s*0.45,s*0.1,s*0.06,0,Math.PI*2);
      ctx.fill();
      // Peak/visor
      ctx.fillStyle='rgba(0,0,0,0.15)';
      ctx.beginPath();
      ctx.ellipse(s*0.62,s*0.65,s*0.22,s*0.07,-0.3,0,Math.PI*2);
      ctx.fill();
    }
  };

  // Color palette — light pink shades (very subtle on pink bg)
  var colors = [
    'rgba(255,77,141,IDX)',    // hot pink
    'rgba(220,50,120,IDX)',    // strong pink
    'rgba(255,105,180,IDX)',   // medium pink
    'rgba(180,0,100,IDX)',     // dark pink
    'rgba(255,150,180,IDX)',   // soft pink
  ];

  // 14 specific items: 3 frocks, 2 tshirts, 3 pants, 3 caps, 3 tshirts
  var itemTypes = [
    'frock','frock','frock',
    'tshirt','tshirt','tshirt',
    'pant','pant','pant',
    'cap','cap','cap','cap',
    'tshirt'
  ];

  var particles = [];
  var cols = 4;
  var rows = Math.ceil(itemTypes.length / cols);

  function resize() {
    canvas.width = section.offsetWidth;
    canvas.height = section.offsetHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  for (var i = 0; i < itemTypes.length; i++) {
    var col = i % cols;
    var row = Math.floor(i / cols);
    var opacity = (0.22 + Math.random() * 0.12).toFixed(2);
    particles.push({
      x: (col / cols) * canvas.width + (Math.random() * canvas.width / cols * 0.7) + (canvas.width / cols * 0.15),
      y: (row / rows) * canvas.height + (Math.random() * canvas.height / rows * 0.7) + (canvas.height / rows * 0.15),
      type: itemTypes[i],
      size: 55 + Math.random() * 25,
      speedX: (Math.random() - 0.5) * 0.5,
      speedY: -0.35 - Math.random() * 0.45,
      opacity: 0.22 + Math.random() * 0.12,
      rotation: (Math.random() - 0.5) * 0.6,
      rotSpeed: (Math.random() - 0.5) * 0.008,
      sway: Math.random() * Math.PI * 2,
      swaySpeed: 0.012 + Math.random() * 0.015,
      swayAmount: 0.8 + Math.random() * 1.2,
      colorIdx: Math.floor(Math.random() * colors.length),
    });
  }

  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    particles.forEach(function(p) {
      ctx.save();
      ctx.globalAlpha = p.opacity;
      ctx.translate(p.x + p.size/2, p.y + p.size/2);
      ctx.rotate(p.rotation);
      // Set fill color
      ctx.fillStyle = colors[p.colorIdx].replace('IDX', p.opacity);
      ctx.strokeStyle = 'rgba(255,255,255,0.15)';
      ctx.lineWidth = 1;
      // Draw clothing shape
      drawers[p.type](ctx, p.size);
      ctx.restore();

      // Smooth wind movement
      p.sway += p.swaySpeed;
      p.x += p.speedX + Math.sin(p.sway) * p.swayAmount;
      p.y += p.speedY + Math.cos(p.sway * 0.7) * 0.3;
      p.rotation += p.rotSpeed + Math.sin(p.sway * 0.5) * 0.003;

      // Wrap around edges
      if (p.y < -p.size * 2) { p.y = canvas.height + p.size; p.x = Math.random() * canvas.width; }
      if (p.x < -p.size * 2) p.x = canvas.width + p.size;
      if (p.x > canvas.width + p.size * 2) p.x = -p.size;
    });
    requestAnimationFrame(animate);
  }
  animate();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function() {
  var grid = document.querySelector('[data-testi-grid]');
  var dotsEl = document.querySelector('[data-testi-dots]');
  if (!grid || !dotsEl) return;

  var reviews = [
    { name: 'Priya Sharma', loc: 'New Delhi', text: 'Best infant store online! Soft fabric, perfect fit. My baby is so comfortable. Arrived in 5 days!' },
    { name: 'Moumita Roy', loc: 'Kolkata, WB', text: 'Ordered for my twin girls. Both loved it! Colours exactly as shown. Free delivery was a bonus!' },
    { name: 'Sunita Devi', loc: 'Patna, BR', text: 'Very soft fabric. My baby is comfortable all day. Fast delivery to Bihar. Will order again!' },
    { name: 'Anjali Patel', loc: 'Surat, GJ', text: 'Ordered for Annaprashan. Baby looked so beautiful! Got many compliments. Highly recommend!' },
    { name: 'Rekha Sharma', loc: 'Jaipur, RJ', text: 'Excellent quality at this price. My daughter wears it every week and it still looks new!' },
    { name: 'Fatima Begum', loc: 'Lucknow, UP', text: 'My daughter wore it for Eid. Looked gorgeous! Soft fabric, no irritation. Thank you!' },
    { name: 'Kavitha Nair', loc: 'Chennai, TN', text: 'Colour did not fade after washing. Neat stitching. Perfect fit for my 6-month-old!' },
    { name: 'Deepika Reddy', loc: 'Bangalore, KA', text: 'Soft cotton, bright colours. My baby looks adorable! Delivered in 3 days. Very impressed!' },
    { name: 'Heena Shah', loc: 'Ahmedabad, GJ', text: 'My baby wore it for her first photoshoot. Looked so cute! Fabric is gentle on skin.' },
    { name: 'Nandita Ghosh', loc: 'Ranchi, JH', text: 'My daughter loves this dress! Comfortable all day. Ordered 2 more in different colours!' },
    { name: 'Pallavi Singh', loc: 'Chandigarh', text: 'Great value for money. Dress is exactly as shown. Fast delivery to Punjab. Very happy!' },
    { name: 'Lalitha Rao', loc: 'Coimbatore, TN', text: 'My 8-month-old looks so cute! Excellent quality at very affordable price. Recommended!' },
    { name: 'Usha Thomas', loc: 'Vadodara, GJ', text: 'My daughter wore it for a family function. Everyone asked where I bought it!' },
    { name: 'Indrani Bose', loc: 'Siliguri, WB', text: 'Delivered in 3 days to West Bengal! Beautiful outfit. Baby is very comfortable.' },
    { name: 'Yamini Krishnan', loc: 'Vijayawada, AP', text: 'Excellent quality at affordable price. My daughter loves this outfit! Will order more.' },
    { name: 'Bindu Menon', loc: 'Kochi, KL', text: 'Fast delivery, beautiful product. My daughter is very happy with it! Great store!' },
    { name: 'Gargi Das', loc: 'Guwahati, AS', text: 'Lovely dress for my baby girl. Soft and comfortable fabric. Delivered in 4 days!' },
    { name: 'Radha Mishra', loc: 'Udaipur, RJ', text: 'My daughter wore it for Diwali. Got so many compliments! Highly recommend ShoppingMood.' },
    { name: 'Meghna Tiwari', loc: 'Jalandhar, PB', text: 'My daughter loves this dress. Soft fabric and beautiful design. Worth every rupee!' },
    { name: 'Savita Patil', loc: 'Hubli, KA', text: 'Nice quality and accurate sizing. My girl looks beautiful. Will definitely order again!' },
    { name: 'Aarti More', loc: 'Nashik, MH', text: 'My baby wore this for her school function. Loved by everyone! Soft and comfy.' },
    { name: 'Shabnam Khan', loc: 'Bhopal, MP', text: 'Perfect outfit for my little one. Great fabric and fast delivery. Very satisfied!' },
    { name: 'Lakshmi Pillai', loc: 'Thiruvananthapuram, KL', text: 'Lovely colour and soft fabric. My daughter wears it every week! Excellent quality.' },
    { name: 'Jaya Krishnan', loc: 'Mysore, KA', text: 'Beautiful dress for my baby girl. She looks like a princess! Highly recommended.' }
  ];

  var perPage = 4;
  var pages = Math.ceil(reviews.length / perPage);
  var current = 0;
  var timer = null;

  function render(page) {
    current = page;
    var batch = reviews.slice(page * perPage, page * perPage + perPage);
    grid.style.opacity = '0';
    setTimeout(function() {
      grid.innerHTML = '';
      batch.forEach(function(r) {
        var card = document.createElement('div');
        card.className = 'sm-testi__card';
        card.innerHTML =
          '<div class="sm-testi__top"><div>' +
          '<div class="sm-testi__name">' + r.name + '</div>' +
          '<div class="sm-testi__loc"><i class="fas fa-map-marker-alt"></i> ' + r.loc + '</div>' +
          '</div><div class="sm-testi__rating">★★★★★</div></div>' +
          '<div class="sm-testi__verified"><i class="fas fa-check-circle"></i> Verified Buyer</div>' +
          '<p class="sm-testi__body">\u201c' + r.text + '\u201d</p>';
        grid.appendChild(card);
      });
      grid.style.opacity = '1';
      dotsEl.querySelectorAll('.sm-testi__dot').forEach(function(d, i) {
        d.classList.toggle('is-active', i === page);
      });
    }, 300);
  }

  for (var i = 0; i < pages; i++) {
    var dot = document.createElement('span');
    dot.className = 'sm-testi__dot' + (i === 0 ? ' is-active' : '');
    dot.dataset.page = i;
    dot.addEventListener('click', function() {
      render(parseInt(this.dataset.page));
      restart();
    });
    dotsEl.appendChild(dot);
  }

  function restart() {
    if (timer) clearInterval(timer);
    timer = setInterval(function() { render((current + 1) % pages); }, 4000);
  }

  grid.style.transition = 'opacity 0.3s ease';
  render(0);
  restart();
})();

  } catch(e) { console.error(e); }
})();
})();
